/**
 * [LEGAL PLACEHOLDER] Contracting entity is confirmed (GameCodex, per
 * dicetok's Terms §9 fixup); the venue (which state/country's courts, which
 * state's law) is not, and is left generic below. Do not treat this file as
 * attorney-reviewed; it describes real behavior accurately but the
 * boilerplate needs a real legal pass before this is load-bearing for a
 * dispute.
 */
export function Terms({ onNavigate }: { onNavigate: (path: string) => void }) {
  return (
    <article className="legal">
      <a
        href="/"
        className="back"
        onClick={(e) => {
          e.preventDefault()
          onNavigate('/')
        }}
      >
        ← Back to Mythzord
      </a>
      <h1>Terms &amp; Conditions</h1>
      <p className="updated">Last updated 2026-07-25</p>

      <p>
        Mythzord is a fictional chat platform from a television show — a parody, not affiliated
        with any real platform. There is no account to create; by sending a message you agree to
        these terms.
      </p>

      <h2>1. Eligibility</h2>
      <p>
        Mythzord doesn't collect an age or identity from you, but the Service is not directed to
        children under 13 and isn't intended for them.
      </p>

      <h2>2. Your messages — nothing is delivered, nothing is stored</h2>
      <p>
        This is the entire premise, not fine print. Anything you type into the composer is sent
        only to generate Sergeant Chill's automated mute response (see §3, AI Policy). It is never
        posted to a channel, never shown to any other visitor, and never stored by Mythzord or
        Atlas after that one response is generated. There is no message history, no database of
        submissions, and nothing to delete later — because nothing was kept.
      </p>

      <h2>3. AI Policy</h2>
      <p>Read this section before you send anything — it's the part that's easy to miss.</p>
      <ul>
        <li>
          <strong>What happens automatically:</strong> every message is sent to a third-party AI
          model (Claude, by Anthropic) via our backend (Atlas), which generates the mute verdict
          you see in real time. Nothing about that response is written or reviewed by a person
          before it's shown to you — it's fully automated.
        </li>
        <li>
          <strong>It's satire, not a factual claim, and there is no human review.</strong>{' '}
          "Sergeant Chill" is a deliberately unfair, over-strict bit — a parody of heavy-handed
          Discord moderation. Because nothing you send is stored, unlike some other portals in
          this network there is no later human review of your message — the automated response is
          the only thing that ever happens to it.
        </li>
        <li>
          <strong>Don't send sensitive information.</strong> Financial details, medical
          information, government IDs, or anything similarly sensitive about yourself or anyone
          else — this product has no use for it, generates no lasting record of it either way, and
          you shouldn't send it.
        </li>
      </ul>

      <h2>4. Acceptable use</h2>
      <p>Don't send anything that:</p>
      <ul>
        <li>is illegal, or describes illegal acts you actually intend to commit;</li>
        <li>harasses, threatens, or discloses private information about a real person without consent;</li>
        <li>impersonates a real person or organization, or infringes their trademarks/IP;</li>
        <li>sexualizes minors in any way;</li>
        <li>is spam, or an attempt to abuse, flood, or overload the service.</li>
      </ul>
      <p>We may block, rate-limit, or otherwise restrict access for violations of this.</p>

      <h2>5. Intellectual property</h2>
      <p>
        Mythzord, "Sergeant Chill," the Barry Dydax show, and related names, marks, and content are
        owned by GameCodex or its licensors. Mythzord parodies conventions of real chat platforms
        — it does not use any real platform's marks, names, or protected expression.
      </p>

      <h2>6. No warranty</h2>
      <p>
        Mythzord is provided "as is," for entertainment purposes, with no warranty of any kind. We
        don't guarantee the service will be available, error-free, or that AI output will be
        accurate, appropriate, or non-offensive — it's a parody generator, not a fact engine.
      </p>

      <h2>7. Limitation of liability</h2>
      <p>
        To the fullest extent permitted by law, Mythzord / GameCodex is not liable for any
        indirect, incidental, or consequential damages arising from your use of the service.
      </p>

      <h2>8. Termination</h2>
      <p>
        There's no account to terminate. We may block or restrict access from any source that
        violates these terms.
      </p>

      <h2>9. Governing law</h2>
      <p>
        These terms are between you and GameCodex. [Placeholder — the specific state/country whose
        law and courts govern disputes is still to be confirmed.] Until finalized, disputes are
        intended to be handled under GameCodex's home jurisdiction, without regard to
        conflict-of-law principles.
      </p>

      <h2>10. Contact</h2>
      <p>
        Questions about these terms: <a href="mailto:legal@wogd.com">legal@wogd.com</a>.
      </p>
    </article>
  )
}
